@if (promptHints.length) {
  <app-custom-button
    icon="lightbulb_outline"
    tooltip="Prompt ideas"
    [active]="isMenuOpen"
    [matMenuTriggerFor]="hintsMenu"
    (menuClosed)="onMenuClosed()"
    (menuOpened)="onMenuOpened()"
  ></app-custom-button>
}

<mat-menu #hintsMenu="matMenu">
  <div class="menu-title">Prompt suggestions</div>
  @for (hint of promptHints; track $index) {
    <button (click)="updateMessage(hint)" mat-menu-item>
      <span>{{ hint }}</span>
    </button>
  }
</mat-menu>
